import { useQuery } from '@tanstack/react-query'
import { baseURL } from '@/v2/constants/requests'

export const useNotification = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['Notification'],
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/notifications.json`)
      if (!res.ok) {
        throw new Error('We could not find messages')
      }
      const result = await res.json()
      return result
    },
  })

  return { notification: data, isLoading, isError }
}
